import React, { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle, AlertTriangle, XCircle, Info } from 'lucide-react';

const ToastCtx = createContext(null);

const TOAST_META = {
  success: { Icon: CheckCircle,  color: '#2a8a5a' },
  warning: { Icon: AlertTriangle, color: '#d08000' },
  danger:  { Icon: XCircle,      color: '#a02020' },
  info:    { Icon: Info,         color: '#0090d0' },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, variant = 'info', duration = 2500) => {
    const id = Date.now() + Math.random();
    setToasts(t => [...t, { id, message, variant }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), duration);
  }, []);

  return (
    <ToastCtx.Provider value={{ showToast }}>
      {children}
      <div style={{
        position: 'fixed', top: 16, right: 16, zIndex: 2100,
        display: 'flex', flexDirection: 'column', gap: 8,
        pointerEvents: 'none',
      }}>
        {toasts.map(t => {
          const meta = TOAST_META[t.variant] || TOAST_META.info;
          const Icon = meta.Icon;
          return (
            <div key={t.id} style={{
              background: '#fff',
              borderRadius: 10,
              border: `1px solid ${meta.color}28`,
              borderLeft: `4px solid ${meta.color}`,
              padding: '10px 14px',
              width: 300,
              boxShadow: '0 4px 20px rgba(80,120,160,0.12)',
              display: 'flex', alignItems: 'center', gap: 10,
              fontSize: 13, color: '#1a2a3a',
              fontFamily: "'Inter',sans-serif",
              animation: 'toastIn 0.18s ease',
              pointerEvents: 'auto',
            }}>
              <Icon size={16} color={meta.color} style={{ flexShrink: 0 }} />
              <span>{t.message}</span>
            </div>
          );
        })}
      </div>
      <style>{`@keyframes toastIn { from { opacity:0; transform:translateX(110%); } to { opacity:1; transform:translateX(0); } }`}</style>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
